import { data } from '../../svg/Comment/data';
import { makeIcon } from '../makeIcon';

export const Comment = makeIcon(data, 'comment', 'Comment');

export default Comment;
